import {ActionTree} from 'vuex';
import {FlowDesignerState} from '../.';
import { AppState } from '../../app';
import { REMOVE_PATH, SET_CURRENT_PATH } from './mutationTypes';
import { DELETE_PATH } from './actionTypes';
import { REMOVE_TRANSITION } from '@/store/bot-designer/states/mutationTypes';
import { StateViewModel, PathViewModel } from '@/features/bots/models/designer';
import { pathContainsFlowVariable, removeFlowVariableFromState, checkStateForInvalidDecisions, getFlowVariablesForPath } from '@/features/bots/services/flowVariableUtils';

export const actions: ActionTree<FlowDesignerState, AppState> = {
	[DELETE_PATH]({ commit, state, getters }, pathId: string) {
		const pathToDelete = state.currentFlow.paths.find(path => {
			return path.id === pathId;
		});
		commit(REMOVE_PATH, pathId);
		const linkedPaths = getters.linkedPaths;
		for (const linkedPath of linkedPaths) {
			for (const currentState of linkedPath.states) {
				commit(REMOVE_TRANSITION, { state: currentState, pathId });
			}
		}

		deleteUnusedFlowVariables(state, pathToDelete!, state.currentFlow.paths);

		if (state.currentPathId === pathId) {
			// switch to the first path in the list
			if (state.currentFlow.paths.length > 0) {
				commit(SET_CURRENT_PATH, state.currentFlow.paths[0].id);
			}
		}

	},
};

function deleteUnusedFlowVariables(state: FlowDesignerState, pathToRemove: PathViewModel, paths: PathViewModel[]) {
	const storedFlowVariables = getFlowVariablesForPath(pathToRemove);

	if (storedFlowVariables.length === 0) {
		return;
	}

	storedFlowVariables.forEach((flowVariable) => {
		const variableUsedElsewhere = state.currentFlow.paths.some(path => pathContainsFlowVariable(path, flowVariable));
		if (!variableUsedElsewhere) {
			removeFlowVariableFromState(state, flowVariable);
			paths.forEach((p: PathViewModel) => {
				p.states.forEach((pathState: StateViewModel) => {
					checkStateForInvalidDecisions(flowVariable, pathState);
				});
			});
		}
	});
}
